export const ANIMATION_DURATION = 0.2;
export const ANIMATION_BUTTON_DURATION = 0.1;
export const SLIDE_TRANSITION = {
    duration: ANIMATION_DURATION * 2,
    ease: "easeInOut",
    type: "tween",
};
